<template>
	<div>
		<div class="level action mb-0">
			<div class="level-left">
				<div class="level-item">
					<month-selector @change-year="onYearSelectChange" @change-month="onMonthSelectChange" @click-previous-month="onMonthPreviousButtonClick" @click-next-month="onMonthNextButtonClick"></month-selector>
				</div>
			</div>

			<div class="level-right">
				<div class="level-item action-buttons">
					<b-button class="" type="is-info" @click="onExportButtonClick">エクスポート</b-button>
				</div>
			</div>
		</div>

		<card class="is-card-table has-pagination has-table-borderless has-bottom-left-hidden" title="" icon="">
			<schedule-table-toolbar slot="toolbar" :dateProvided="date" :isDateShow="true" :year="year" :month="month" :staffs="staffs" :shops="shops" @search-button-click="onSearchButtonClick" @input="onDateInput"/>

			<b-table
					:checkable="false"
					:loading="isLoading"
					:paginated="false"
					:striped="true"
					:hoverable="true"
					default-sort="date"
					:data='data'
					detailed
					detail-key="id"
					:show-detail-icon="true"
					>
		
				<template slot-scope="props">
					<b-table-column label="日程" field="date" sortable>
						{{ props.row.date }}
					</b-table-column>
					<b-table-column label="開始" field="schedule_start" sortable>
						{{ props.row.schedule_start }}
					</b-table-column>
					<b-table-column label="終了" field="schedule_end" sortable>
						{{ props.row.schedule_end }}
					</b-table-column>
					<b-table-column label="起床確認" field="wakeup" sortable>
						{{ props.row.wakeup }}
					</b-table-column>
					<b-table-column label="出勤" field="start" sortable>
						{{ props.row.start }}
					</b-table-column>
					<b-table-column label="退勤" field="end" sortable>
						{{ props.row.end }}
					</b-table-column>
					<b-table-column label="店舗" field="shop" sortable>
						{{ props.row.shop }}
					</b-table-column>
					<b-table-column label="スタッフ" field="staff_name" sortable>
						{{ props.row.staff_name }}
					</b-table-column>
					<b-table-column label="次シフト確認" field="is_next_work_confirmed" centered>
						<b-icon type="is-success" icon="check" v-if="props.row.is_next_work_confirmed"></b-icon>
					</b-table-column>
					<b-table-column label=" ">
						<div class="buttons is-right">
							<button class="button is-small is-info" type="button" v-if="props.row.is_mail_button_show" @click="onSendMailButtonClick(props.row.id)">メール送信</button>
						</div>
					</b-table-column>
				</template>
				
				<template slot="detail" slot-scope="props">
					<div class="detail">
						<div v-if="isAi" class="mr-40">
							<a class="selfy" :href="props.row.selfy_url" target="_blank"><img :src="props.row.selfy_url"></a>
							<div>スマイル：{{ props.row.smile }}</div>
						</div>
						<div class="mr-20">
							<textarea class="report textarea" v-model="reports[props.row.id]"></textarea>
						</div>
						<div>
							<button class="button is-success report-button" :class="{ 'is-loading': isReportButtonLoading }" v-if="props.row.end !== ''" @click="onReportButtonClick(props.row.id)">日報更新</button>
						</div>
					</div>
				</template>
		
				<section class="section" slot="empty">
					<div class="content has-text-grey has-text-centered">
						<template v-if="isLoading">
						</template>
						<template v-else>
							<p>データはありません</p>
						</template>
					</div>
				</section>
			</b-table>
		</card>
	</div>
</template>

<script>
import Card from "@/components/Card";
import ScheduleTableToolbar from "@/components/ScheduleTableToolbar";
import MonthSelector from "@/components/MonthSelector";
import qs from 'qs';
import moment from 'moment';

export default {
	name: 'work-summary',
	components: {
		Card,
		ScheduleTableToolbar,
		MonthSelector,
	},
	data() {
		return {
			data: [],
			isLoading: false,
			year: '',
			month: '',
			staffs: null,
			shops: [],
			shopId: '',
			staffId: '',
			date: '',
			isReportButtonLoading: false,
			reports: [],
			isAi: false,
		}
	},
	created() {
		this.year = moment().format('YYYY').toString();
		this.endYear = parseInt(moment().format('YYYY')) + 1;
		for (let i = this.startYear; i <= this.endYear; i++) {
			this.years.push(i);
		}
		this.month = moment().format('M').toString();
	},
	mounted() {
		this.init();
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['出退勤サマリー']
		});
	},
	computed: {
	},
	methods: {
		toggle(row) {
			this.$refs.table.toggleDetails(row)
		},
		onDateInput: function(date) {
			this.date = date;
		},
		onExportButtonClick: async function() {
			let loading = this.$loading.open();

			let ep = `works/export-summary?year=${this.year}&month=${this.month}`;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.downloadCSV(res.data);
			} catch (error) {
				this.$utils.log(error);
				alert(error.response.data.message);
			} finally {
				loading.close();
			}
		},
		downloadCSV: function(data) {
			let fileName = `export_summary_${this.year}${this.$utils.zeroPadding(this.month,2)}.csv`;
			this.$utils.downloadCSV(data, this.year, this.month, fileName, true);
		},
		onReportButtonClick: async function(id) {
			this.isReportButtonLoading = true;

			let data = {
				"id": id,
				"report": this.reports[id],
			};
			this.$utils.log(data);

			let ep = 'works/report';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$utils.toastSuccess('日報を更新しました');
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isReportButtonLoading = false;
			}
		},
		onSendMailButtonClick: async function(id) {
			this.$utils.log('onSendMailButtonClick id = '+id);
			let target = this.data.filter((f) => f.id === id)[0];
			this.$utils.log(target);

			let type = !target.start ? 'start' : 'end';
			let msg = !target.start ? '出勤' : '退勤';
			this.$utils.log(type);

			if (!window.confirm('起床確認メールを送信します。よろしいですか？')) {
				return false;
			}

			this.isLoading = true;
			let data = {
				"id": id,
				"type": 'start',
			};
			this.$utils.log(data);

			let ep = 'works/send-registration-mail';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$utils.toastSuccess('メールを送信しました');
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onYearSelectChange: function(year) {
			this.year = year;
			this.date = '';
			this.getData();
		},
		onMonthSelectChange: function(month) {
			this.month = month;
			this.date = '';
			this.getData();
		},
		onMonthPreviousButtonClick: function(year, month) {
			this.year = year;
			this.month = month;
			this.date = '';
			this.getData();
		},
		onMonthNextButtonClick: function(year, month) {
			this.year = year;
			this.month = month;
			this.date = '';
			this.getData();
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			this.isLoading = true;
			let data = {
				"year": this.year,
				"month": this.month,
				"staff_id": this.staffId,
				"shop_id": this.shopId,
				"date": this.date,
			};
			this.$utils.log(data);

			let ep = 'works/summary?' + qs.stringify(data);
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				if (!res.data.list) {
					this.data = [];
				} else {
					this.data = res.data.list;
				}
				this.totalNum = this.data.length;
				this.staffs = res.data.staffs;
				this.shops = res.data.shops;
				this.reports = res.data.reports;
				this.isAi = res.data.is_ai;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onSearchButtonClick: function(staffId, shopId, date) {
			this.$utils.log('onSearchButtonClick');
			this.staffId = staffId;
			this.shopId = shopId;
			this.date = date;
			this.getData();
		},
	},
}
</script>

<style scoped>
.selfy {
	display: block;
	width: 150px;
	height: auto;

	img {
		border: #ccc 1px solid;
	}
}
.detail {
	display: flex;
}
.report {
	width: 400px;
	height: 300px;
}

</style>
